import Api from '../api';

export const ProportionalSale = async (payment_form: number, services_ids: Array<number>) => {
  const response = await Api.get(`/api/controle_crm/proportional_sale_simulation`, {
    params: { payment_form, services_ids },
  });
  return response;
};
